//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 20.07.2015.
 */

(function () {

    'use strict';

    var module = angular.module('container', [

        'ui.router',
        'ngMockE2E',
        'ngResource',
        'ngAnimate',
        'pascalprecht.translate',
        'angularMoment',
        'ngMessages',
        'angular-cache',
        'container.core',
        'container.widgets',
        'container.layout',
        'container.util',
        'container.components', 
        'ui.router.state.events'
    ]).config(['$httpProvider', function($httpProvider) {

        let logoutTimer;

        $httpProvider.defaults.headers.common['Access-Token'] = window._keycloak.token;
        setLogoutTimer();

        window._keycloak.onAuthRefreshSuccess = () => {
            $httpProvider.defaults.headers.common['Access-Token'] = window._keycloak.token;
            
            if (localStorage.getItem('accessTokenUpdatedBy') === 'user') {
                setLogoutTimer();
            }            
        }

        function setLogoutTimer() {
            clearTimeout(logoutTimer);

            const refreshTokenExpiresIn = window._keycloak.refreshTokenParsed.exp - window._keycloak.refreshTokenParsed.iat - 5;

            console.log('logout timer set for ' + refreshTokenExpiresIn + 'seconds', new Date());
            logoutTimer = setTimeout(() => {
                console.info('Refresh Token expired '+ new Date());
                window._keycloak.clearToken();
                window._keycloak.logout();
            }, refreshTokenExpiresIn*1000);
        }

    }]);;

    // Workaround to get angular ui router's ui-view working inside ng-include on the main page
    module.run(function($state) {
    });
})();